import { render, staticRenderFns } from "./CartItems.vue?vue&type=template&id=079f3605&"
import script from "./CartItems.vue?vue&type=script&lang=js&"
export * from "./CartItems.vue?vue&type=script&lang=js&"
import style0 from "./CartItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports